import React, { useState, useEffect } from 'react';
import * as ST from './styled';

const countStep = 30;

export const CounterTitle = ({ maxValue, isStart }) => {
    const [value, setValue] = useState(0);

    useEffect(() => {
        const increment = Math.ceil(maxValue / countStep);
        if (isStart) {
            if (value < maxValue) {
                let newValue = value + increment;
                if (newValue > maxValue) {
                    newValue = maxValue;
                }
                setTimeout(() => {
                    setValue(newValue);
                }, 50);
            }
        }
    }, [value, isStart]);

    return <ST.CounterValue>{value.toLocaleString()}</ST.CounterValue>;
};
